<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="internal" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>
    <section class="dp-right">
      <div class="toolbar-filter-bar">
        <el-form :inline="true" :model="filters" class="toolbar-filter-form">
          <div class="toolbar-filter-fields">
            <el-form-item label="日期">
              <el-date-picker
                v-model="filters.dateRange"
                type="daterange"
                value-format="yyyy-MM-dd"
                start-placeholder="开始"
                end-placeholder="结束"
                class="toolbar-field-w-daterange">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="教师名">
              <el-input
                v-model="filters.teacherName"
                clearable
                placeholder="教职工姓名"
                class="toolbar-field-w-md"
                @keyup.enter.native="handleQuery">
              </el-input>
            </el-form-item>
            <el-form-item label="项目">
              <el-select v-model="filters.itemId" clearable placeholder="全部" class="toolbar-field-w-md htwa-item-select">
                <el-option v-for="item in itemOptions" :key="item.Id" :label="item.ItemName" :value="item.Id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="补卡">
              <el-select v-model="filters.isMakeup" clearable placeholder="全部" class="toolbar-field-w-sm">
                <el-option label="仅正常" :value="false"></el-option>
                <el-option label="仅补卡" :value="true"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" icon="el-icon-search" @click="handleQuery">查询</el-button>
            </el-form-item>
          </div>
          <div class="toolbar-filter-actions">
            <el-button size="small" type="warning" icon="el-icon-download" :loading="exporting" @click="handleExport">导出</el-button>
          </div>
        </el-form>
      </div>

      <div class="tbl-scroll-host">
      <el-table :data="rows" v-loading="listLoading" stripe height="100%">
        <el-table-column label="考勤日期" width="110" align="center">
          <template slot-scope="scope">{{ formatDate(scope.row.AttendanceDate) }}</template>
        </el-table-column>
        <el-table-column label="打卡时间" min-width="160" align="center">
          <template slot-scope="scope">{{ formatDateTime(scope.row.PunchTime) }}</template>
        </el-table-column>
        <el-table-column prop="TeacherName" label="教职工" min-width="100" align="center"></el-table-column>
        <el-table-column prop="ClassName" label="班级/类型" min-width="120" align="center"></el-table-column>
        <el-table-column prop="ItemName" label="项目" min-width="110" align="center"></el-table-column>
        <el-table-column prop="ScheduleName" label="时段" min-width="100" align="center"></el-table-column>
        <el-table-column label="时段时间" width="120" align="center">
          <template slot-scope="scope">
            {{ formatTime(scope.row.ScheduleStart) }}-{{ formatTime(scope.row.ScheduleEnd) }}
          </template>
        </el-table-column>
        <el-table-column label="补卡" width="70" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsMakeup ? 'warning' : 'success'" size="mini">
              {{ scope.row.IsMakeup ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Address" label="定位" min-width="140" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="PhotoCount" label="照片数" width="80" align="center"></el-table-column>
        <el-table-column label="操作" width="90" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="openDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <div class="pagination-container">
        <el-pagination
          layout="total, prev, pager, next"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          style="float: right"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>

      <el-dialog title="打卡详情" :visible.sync="detailVisible" width="720px" append-to-body>
        <div v-loading="detailLoading">
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="教职工">{{ detail.TeacherName }}</el-descriptions-item>
            <el-descriptions-item label="班级/类型">{{ detail.ClassName }}</el-descriptions-item>
            <el-descriptions-item label="项目">{{ detail.ItemName }}</el-descriptions-item>
            <el-descriptions-item label="时段">{{ detail.ScheduleName }}</el-descriptions-item>
            <el-descriptions-item label="考勤日期">{{ formatDate(detail.AttendanceDate) }}</el-descriptions-item>
            <el-descriptions-item label="打卡时间">{{ formatDateTime(detail.PunchTime) }}</el-descriptions-item>
            <el-descriptions-item label="是否补卡">{{ detail.IsMakeup ? '是' : '否' }}</el-descriptions-item>
            <el-descriptions-item label="定位">{{ detail.Address || '-' }}</el-descriptions-item>
            <el-descriptions-item label="拍照要求" :span="2">{{ detail.PhotoRequireDesc || '-' }}</el-descriptions-item>
            <el-descriptions-item label="地点说明" :span="2">{{ detail.LocationDesc || '-' }}</el-descriptions-item>
          </el-descriptions>
          <div style="margin-top: 16px;">
            <div style="margin-bottom: 8px; font-weight: 600;">照片</div>
            <div v-if="detail.Photos && detail.Photos.length" class="photo-list">
              <!-- OSS 私有桶：el-image 直接 :src 无法预签，改用 oss-el-image。最后修改：2026-09-14 -->
              <oss-el-image
                v-for="(p, idx) in detail.Photos"
                :key="p.Id || idx"
                :src="p.FileUrl || p.fileUrl"
                :preview-src-list="photoUrls"
                style="width: 96px; height: 96px; margin-right: 8px; margin-bottom: 8px;"
                fit="cover">
              </oss-el-image>
            </div>
            <div v-else class="field-hint">暂无照片</div>
          </div>
        </div>
        <div slot="footer">
          <el-button type="primary" @click="detailVisible = false">关闭</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import DepartmentPane from "../../components/DepartmentPane";
import {
  getHeadTeacherWorkAttendanceItemOptions,
  getHeadTeacherWorkAttendanceRecordPage,
  getHeadTeacherWorkAttendanceRecordDetail,
  exportHeadTeacherWorkAttendanceRecords,
  downloadHeadTeacherWorkAttendanceBlob,
  resolveHeadTeacherWorkAttendanceSchoolIdFromTreeNode,
  onHeadTeacherWorkAttendanceSchoolChange
} from "@/api/headTeacherWorkAttendance";
import { toDeptId, treeNodeDeptId } from '../../utils/deptCascaderProps';

function todayStr() {
  const d = new Date();
  return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
}

export default {
  components: { DepartmentPane },
  data() {
    const today = todayStr();
    return {
      schoolId: 0,
      DepartmentId: 0,
      scopeDepartmentId: 0,
      filters: {
        dateRange: [today, today],
        teacherName: "",
        itemId: null,
        isMakeup: null,
        teacherMasterId: null,
        classId: null
      },
      itemOptions: [],
      rows: [],
      page: 1,
      pageSize: 10,
      total: 0,
      listLoading: false,
      exporting: false,
      detailVisible: false,
      detailLoading: false,
      detail: {},
      photoUrls: [],
      ignoreDefaultTreeSelectionFromRoute: false
    };
  },
  mounted() {
    this.applyRouteQuery();
  },
  methods: {
    applyRouteQuery() {
      const q = this.$route.query || {};
      if (q.schId) {
        this.schoolId = toDeptId(q.schId);
        this.DepartmentId = this.schoolId;
      }
      if (q.startDate && q.endDate) {
        this.filters.dateRange = [q.startDate, q.endDate];
      }
      if (q.itemId) this.filters.itemId = Number(q.itemId);
      if (q.teacherMasterId) this.filters.teacherMasterId = Number(q.teacherMasterId);
      if (q.classId) this.filters.classId = Number(q.classId);
      if (q.isMakeup === "true") this.filters.isMakeup = true;
      if (q.isMakeup === "false") this.filters.isMakeup = false;
      if (this.schoolId) {
        this.ignoreDefaultTreeSelectionFromRoute = true;
        this.loadItems().then(() => this.loadData());
      }
    },
    formatDate(val) {
      return val ? String(val).substring(0, 10) : "";
    },
    formatDateTime(val) {
      return val ? String(val).replace("T", " ").substring(0, 19) : "";
    },
    formatTime(val) {
      return val ? String(val).substring(0, 5) : "";
    },
    async treeNodeClick(data, node, component) {
      if (this.ignoreDefaultTreeSelectionFromRoute && (!component || !component.$el)) {
        this.ignoreDefaultTreeSelectionFromRoute = false;
        return;
      }
      this.ignoreDefaultTreeSelectionFromRoute = false;
      const schId = resolveHeadTeacherWorkAttendanceSchoolIdFromTreeNode(node, data && data.value);
      const scopeId = treeNodeDeptId(data) || schId;
      onHeadTeacherWorkAttendanceSchoolChange(this, schId, scopeId);
      this.filters.teacherMasterId = null;
      this.filters.classId = null;
      if (!schId) return this.$message.warning("请选择学校或其下级节点");
      await this.loadItems();
      this.handleQuery();
    },
    async loadItems() {
      this.itemOptions = await getHeadTeacherWorkAttendanceItemOptions(this.schoolId);
    },
    buildParams() {
      const range = this.filters.dateRange || [];
      return {
        SchId: this.schoolId,
        ScopeDepartmentId: this.filters.classId ? null : (this.scopeDepartmentId || this.DepartmentId || null),
        StartDate: range[0] || null,
        EndDate: range[1] || null,
        TeacherName: (this.filters.teacherName || "").trim() || null,
        ItemId: this.filters.itemId || null,
        IsMakeup: this.filters.isMakeup,
        TeacherMasterId: this.filters.teacherMasterId || null,
        ClassId: this.filters.classId || null,
        Page: this.page,
        PageSize: this.pageSize
      };
    },
    handleQuery() {
      this.page = 1;
      this.loadData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.loadData();
    },
    async loadData() {
      if (!this.schoolId) return this.$message.warning("请先选择学校");
      this.listLoading = true;
      try {
        const res = await getHeadTeacherWorkAttendanceRecordPage(this.buildParams());
        if (res.data && res.data.success) {
          const pageData = res.data.response || {};
          this.rows = pageData.data || [];
          this.total = pageData.dataCount || 0;
        } else {
          this.rows = [];
          this.total = 0;
          this.$message.error((res.data && res.data.msg) || "查询失败");
        }
      } finally {
        this.listLoading = false;
      }
    },
    async openDetail(row) {
      this.detailVisible = true;
      this.detailLoading = true;
      this.detail = {};
      this.photoUrls = [];
      try {
        const res = await getHeadTeacherWorkAttendanceRecordDetail(this.schoolId, row.Id || row.id);
        if (res.data && res.data.success) {
          this.detail = res.data.response || {};
          const photos = this.detail.Photos || this.detail.photos || [];
          this.photoUrls = photos.map(p => p.FileUrl || p.fileUrl).filter(Boolean);
        } else {
          this.$message.error((res.data && res.data.msg) || "加载详情失败");
        }
      } finally {
        this.detailLoading = false;
      }
    },
    async handleExport() {
      if (!this.schoolId) return this.$message.warning("请先选择学校");
      try {
        const params = this.buildParams();
        params.Page = 1;
        params.PageSize = 9999;
        const res = await exportHeadTeacherWorkAttendanceRecords(params);
        downloadHeadTeacherWorkAttendanceBlob(res, "教职工工作考勤明细.xlsx");
      } catch (e) {
        this.$message.error("导出失败");
      }
    }
  }
};
</script>

<style scoped>
.toolbar-field-w-md.htwa-item-select {
  width: 200px !important;
}
.field-hint {
  color: #909399;
  font-size: 12px;
}
.photo-list {
  display: flex;
  flex-wrap: wrap;
}
</style>
